import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style';
import {
  type,
} from 'ramda';

export default class CheckBox extends Component {

  constructor(props) {
    super(props);
    this.getFieldProp = this.getFieldProp.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.convertBoolean = this.convertBoolean.bind(this);
  }

  getFieldProp(prop) {
    let propItem = null;
    if (prop && this.props.field && this.props.field[prop] !== undefined) {
      propItem = prop === "value" ? this.convertBoolean(this.props.field[prop]) : this.props.field[prop];
    }

    return propItem;
  }

  convertBoolean(value) {
    if(type(value) === "Boolean"){
      return value;
    }else {
      let tmpValue = parseInt(value);
      value = tmpValue === 1;
    }

    return value;
  }

  changeValue() {
    this.props.field.value = !(this.convertBoolean(this.props.field.value));
    if (this.props.relatedTo && this.props.relatedTo.length > 0) {
      this.props.onChange([
          this.props.relatedTo,
          this.props.field.name,
        ],
        this.props.field
      );
    } else {
      this.props.onChange(this.props.field.name, this.props.field);
    }
  }

  render() {
    const containerClass = `form-group ${this.props.className}`;
    const customize = this.props.customize || {};
    return (
      <div className={containerClass} style={customize}>
        <label className="custom-control custom-checkbox" style={customize}>
          <input
            disabled={this.props.disabled}
            type="checkbox"
            className="custom-control-input"
            checked={!!this.getFieldProp('value')}
            onChange={(e) => { this.changeValue(); }}
          />
          <span className="custom-control-indicator" />
          <span
            className="custom-control-description"
            style={style}
          >
            {this.getFieldProp('label')}
          </span>
        </label>
      </div>
    );
  }
}

CheckBox.propTypes = {
  disabled: PropTypes.bool,
  customize: PropTypes.object,
  field: PropTypes.object,
  onChange: PropTypes.func,
  className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/common/CheckBox/index.js